import React from "react";
import Control from '../store/control';
import MarkingCommon from './markingCommon';

const ObjectAk = () => {
  const type     = Control.Get("type");

  return (
    <>
      <MarkingCommon/>
    </>
  );
  
};

export default ObjectAk;